import React, {Component} from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import {ApplicationPaths} from './components/api-authorization/ApiAuthorizationConstants';
import Sidebar from "./components/Sidebar.jsx";
import Fields from "./pages/Fields.jsx";
import Fertilizers from "./pages/Fertilizers.jsx";
import Calculations from "./pages/Calculations.jsx";
import Reports from "./pages/Reports.jsx";
import Profile from "./pages/Profile";
import './App.css';
import './custom.css';
import Directory from "./pages/Directory";
import NotFoundPage from "./pages/NotFoundPage";


export default class App extends Component {
    static displayName = App.name

    render() {
        return (
            <Sidebar>
                <Switch>
                    <AuthorizeRoute exact path="/fields" component={Fields}/>
                    <Redirect exact from="/" to="/fields" />
                    <AuthorizeRoute path='/directory' component={Directory}/>
                    <AuthorizeRoute path='/fertilizers' component={Fertilizers}/>
                    <AuthorizeRoute path='/calculations' component={Calculations}/>
                    <AuthorizeRoute path='/reports' component={Reports}/>
                    <AuthorizeRoute path='/profile' component={Profile}/>
                    <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes}/>
                    <Route component={NotFoundPage}/>
                </Switch>
            </Sidebar>
        );
    }
}
